const MOBILE_BREAKPOINT = 768
const TABLET_BREAKPOINT = 1024

const detectBreakpoint = (target = '', width = window.innerWidth) => {
  switch (target) {
    case 'desktop':
      return width > TABLET_BREAKPOINT
    case 'tablet':
      return width >= MOBILE_BREAKPOINT && width < TABLET_BREAKPOINT
    default:
      return width < MOBILE_BREAKPOINT
  }
}

const detectCurrentBreakpoint = () => {
  const width = window.innerWidth

  if (width < MOBILE_BREAKPOINT) {
    return 'mobile'
  } else if (width >= MOBILE_BREAKPOINT && width < TABLET_BREAKPOINT) {
    return 'tablet'
  } else if (width > TABLET_BREAKPOINT) {
    return 'desktop'
  }
}

export { detectBreakpoint, detectCurrentBreakpoint }
